var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        top: "5vh",
        width: "70%",
        title: "指派",
        modal: false,
        visible: _vm.dialogVisibleAssign,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        "before-close": _vm.handleCloseAssign
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisibleAssign = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "80px" } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "assign_summernote_item",
              attrs: { label: "回复工单" }
            },
            [
              _c("EditorSummernote", {
                ref: "summernote_3",
                attrs: { id: "assign_summernote" },
                model: {
                  value: _vm.assign.content,
                  callback: function($$v) {
                    _vm.$set(_vm.assign, "content", $$v)
                  },
                  expression: "assign.content"
                }
              }),
              _vm._v(" "),
              _c("TicketUpload", { ref: "up3" }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { width: "110px" },
                  attrs: { title: "点我可将工单抄送给指定人" },
                  on: {
                    click: function($event) {
                      _vm.ticketCcShow = !_vm.ticketCcShow
                    }
                  }
                },
                [_vm._v("抄送(通知)")]
              ),
              _vm._v(" "),
              _c("TicketTemplateSelect", {
                on: { selected: _vm.onTicketTemplateSelected }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.workflow
            ? _c(
                "el-form-item",
                { attrs: { label: "指派给" } },
                [
                  _c("WorkflowSelect", {
                    ref: "WorkflowSelect",
                    staticStyle: { width: "308px" },
                    on: { change: _vm.onWorkflowSelectChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.assign.workflowId
            ? _c(
                "el-form-item",
                { attrs: { label: "处理人" } },
                [
                  _c("DealUserSearch", {
                    ref: "assignUser_1",
                    staticStyle: { width: "308px" },
                    on: { change: _vm.updateAssignUserId },
                    model: {
                      value: _vm.assign.assignUserId,
                      callback: function($$v) {
                        _vm.$set(_vm.assign, "assignUserId", $$v)
                      },
                      expression: "assign.assignUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ticketCcShow
            ? _c(
                "el-form-item",
                { staticStyle: { width: "100%" }, attrs: { label: "抄送" } },
                [
                  _c("NoticeUserSearch", {
                    attrs: { id: _vm.assign.orderNoticeList },
                    on: { change: _vm.updateNoticeIdsAssign }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.assign.workflowId
        ? _c(
            "div",
            { staticStyle: { padding: "0 15px 0 15px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 0 5px 0",
                    "border-top": "1px solid #F0F8FF"
                  }
                },
                [
                  _c("span", { staticClass: "strong" }, [_vm._v("表单")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "load_form_btn",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { title: "关闭表单, 取消选择这个工作流" },
                      on: { click: _vm.closeTicketForm }
                    },
                    [_vm._v("x")]
                  ),
                  _vm._v(" "),
                  _c("LoadFormData", {
                    staticClass: "load_form_btn",
                    on: { selected: _vm.onLoadFormDataSelected }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TicketTaskForm",
                {
                  ref: "taskForm1",
                  attrs: {
                    workflowId: _vm.assign.workflowId,
                    fromDialog: "Yes",
                    hideSubmitButtom: "true"
                  },
                  model: {
                    value: _vm.assign.ticketForm,
                    callback: function($$v) {
                      _vm.$set(_vm.assign, "ticketForm", $$v)
                    },
                    expression: "assign.ticketForm"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "no_form_1",
                      attrs: { slot: "no_form" },
                      slot: "no_form"
                    },
                    [_vm._v("没有表单")]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCloseAssign } }, [
            _vm._v("取消")
          ]),
          _vm._v(" "),
          _c("SubmitTicketButton", {
            ref: "assignBtn_1",
            attrs: { buttonText: "提交" },
            on: { click: _vm.assignOrder }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e0c4534", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e0c4534","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketAssignDialog.vue
// module id = 796
// module chunks = 75